var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-page-layout"},[_vm._t("default"),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }